import { useQuery } from '@tanstack/react-query';
import { fetchMLSData } from '../../../api/mls';

/**
 * React Query key factory for MLS data
 */
export const mlsKeys = {
  all: ['mls'] as const,
  details: (boardCode: string) => [...mlsKeys.all, 'details', boardCode] as const,
};

/**
 * Custom hook to fetch MLS data by board code using React Query
 * @param boardCode The MLS board code to fetch data for
 * @param enabled Whether the query should be enabled (defaults to true if boardCode is provided)
 * @returns Query result with MLS data
 */
export const useMLSData = (boardCode?: string, enabled = !!boardCode) => {
  return useQuery({
    queryKey: boardCode ? mlsKeys.details(boardCode) : mlsKeys.all,
    queryFn: async () => {
      if (!boardCode) {
        throw new Error('Board code is required to fetch MLS data');
      }
      return fetchMLSData(boardCode);
    },
    enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 30, // 30 minutes
  });
};
